import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import {
  validateEmail,
  validateRequired,
} from 'components/shared/Forms/ReduxForm'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { importDealers } from 'redux/importer'
import { confirmationModal } from 'redux/navigation'
import {
  archiveAllDealers,
  importAllNewDealers,
  updateAllDealers,
} from 'redux/userAdmin'
import { Button, Header, Icon, Popup, Segment, Table } from 'semantic-ui-react'
import Badge from '../Helper/Badge'

const mapStateToProps = (state) => {
  const {
    loadingDealerState, // boolean showing state (new, updated, deleted) is loading
    dealerState, // object reflecting new, changed, deleted dealers, errors and import date
  } = state.importer
  const { language } = state.navigation
  return { loadingDealerState, dealerState, language }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      importDealers,
      push,
      confirmationModal,
      importAllNewDealers,
      updateAllDealers,
      archiveAllDealers,
    },
    dispatch
  )
}

const itemsPerPage = 10

class ImporterDealers extends React.Component {
  state = {
    newDealersPageNumber: 0,
    updatedDealersPageNumber: 0,
    deletedDealersPageNumber: 0,
  }

  constructor(props) {
    super(props)
    this.increaseNewDealersPage = this.increaseNewDealersPage.bind(this)
    this.decreaseNewDealersPage = this.decreaseNewDealersPage.bind(this)
    this.increaseUpdatedDealersPage = this.increaseUpdatedDealersPage.bind(this)
    this.decreaseUpdatedDealersPage = this.decreaseUpdatedDealersPage.bind(this)
    this.increaseDeletedDealersPage = this.increaseDeletedDealersPage.bind(this)
    this.decreaseDeletedDealersPage = this.decreaseDeletedDealersPage.bind(this)
  }

  getDealerRows(dealers, path, pageVariable) {
    const { [pageVariable]: pageNumber } = this.state
    const { language } = this.props
    const { push } = this.props
    const dark = config.theme.dark

    return dealers
      .slice(pageNumber * itemsPerPage, (pageNumber + 1) * itemsPerPage)
      .map((dealer, index) => (
        <Table.Row
          onClick={(event) => {
            event.preventDefault()
            push(path + dealer.id)
          }}
          error={
            !!(
              dealer.conflict ||
              validateEmail(dealer.email) ||
              validateRequired(dealer.email)
            )
          }
          key={index}
          verticalAlign="top">
          <Table.Cell>
            <div
              className="ellipsis"
              style={
                dealer.conflict ||
                validateEmail(dealer.email) ||
                validateRequired(dealer.email)
                  ? { float: 'left' }
                  : {}
              }>
              {dealer.address1}
              <span className="unobtrusive" children={` (${dealer.place})`} />
            </div>
            {!!(
              dealer.conflict ||
              validateEmail(dealer.email) ||
              validateRequired(dealer.email)
            ) && (
              <Popup
                trigger={<Icon link name="warning circle" color="red" />}
                children={I18n.t('admin.importer.dealers.hint_email')}
                inverted={dark}
                style={{ borderRadius: '4px' }}
                size="tiny"
              />
            )}
          </Table.Cell>
          <Table.Cell
            className="unobtrusive"
            textAlign="right"
            children={new Date(dealer.updated_at).toLocaleDateString(
              language,
              config.format.date_time
            )}
          />
        </Table.Row>
      ))
  }

  decreaseNewDealersPage() {
    const { newDealersPageNumber } = this.state
    this.setState({ newDealersPageNumber: newDealersPageNumber - 1 })
  }

  increaseNewDealersPage() {
    const { newDealersPageNumber } = this.state
    this.setState({ newDealersPageNumber: newDealersPageNumber + 1 })
  }

  decreaseUpdatedDealersPage() {
    const { updatedDealersPageNumber } = this.state
    this.setState({ updatedDealersPageNumber: updatedDealersPageNumber - 1 })
  }

  increaseUpdatedDealersPage() {
    const { updatedDealersPageNumber } = this.state
    this.setState({ updatedDealersPageNumber: updatedDealersPageNumber + 1 })
  }

  decreaseDeletedDealersPage() {
    const { deletedDealersPageNumber } = this.state
    this.setState({ deletedDealersPageNumber: deletedDealersPageNumber - 1 })
  }

  increaseDeletedDealersPage() {
    const { deletedDealersPageNumber } = this.state
    this.setState({ deletedDealersPageNumber: deletedDealersPageNumber + 1 })
  }

  render() {
    const {
      newDealersPageNumber,
      updatedDealersPageNumber,
      deletedDealersPageNumber,
    } = this.state
    const { loadingDealerState, dealerState } = this.props
    const { push } = this.props
    const {
      confirmationModal,
      importAllNewDealers,
      updateAllDealers,
      archiveAllDealers,
    } = this.props

    const newDealersPages = Math.ceil(dealerState.new.length / itemsPerPage)
    const updatedDealersPages = Math.ceil(
      dealerState.updated.length / itemsPerPage
    )
    const deletedDealersPages = Math.ceil(
      dealerState.deleted.length / itemsPerPage
    )

    const dark = config.theme.dark

    return loadingDealerState ? (
      <ComponentPlaceholder />
    ) : (
      <div className={classNames(['importerDealers', dark && 'inverted'])}>
        <ComponentHeader
          title={I18n.t('admin.importer.dealers.title')}
          customActions={[
            <Button
              icon="chevron right"
              labelPosition="right"
              color="blue"
              content={I18n.t('admin.importer.dealers.all')}
              onClick={(event) => {
                event.preventDefault()
                push(config.nodes.dealersFromDashboard)
              }}
            />,
          ]}
        />

        <Segment attached className="filterBar primary status">
          {dealerState.last_sync && (
            <Header
              as="h4"
              content={I18n.t('admin.importer.dealers.last_sync', {
                lastSync: new Date(dealerState.last_sync).toLocaleString(),
              })}
            />
          )}
          {dealerState.last_change && (
            <Header
              as="h4"
              className="important"
              content={I18n.t('admin.importer.dealers.last_change', {
                lastChange: new Date(dealerState.last_change).toLocaleString(),
              })}
            />
          )}
        </Segment>

        <Segment
          disabled={!dealerState.new_count > 0}
          attached
          className={classNames([dark && 'inverted', 'payload', 'clip'])}>
          <Header size="medium" className="payload-title">
            {I18n.t('admin.importer.dealers.new_dealers')}
            <Badge count={dealerState.new_count} />
            <Button
              disabled={!dealerState.new_count > 0}
              inverted={dark}
              content={I18n.t('admin.importer.dealers.import_all')}
              size="tiny"
              floated="right"
              icon={config.icons.modalApprove}
              onClick={() =>
                confirmationModal({
                  icon: config.icons.modalApprove,
                  title: I18n.t('admin.importer.dealers.import_new'),
                  text: I18n.t(
                    'admin.importer.dealers.import_new_confirmation',
                    { numItems: dealerState.new_count }
                  ),
                  button: I18n.t('admin.importer.dealers.import_all'),
                  confirm: () => importAllNewDealers(),
                })
              }
            />
          </Header>
          <Table
            inverted={dark}
            sortable
            compact
            size="small"
            selectable
            singleLine
            basic="very"
            className="spaced">
            <Table.Body
              children={this.getDealerRows(
                dealerState['new'],
                config.nodes.dealersImport,
                'newDealersPageNumber'
              )}
            />
          </Table>
          {newDealersPages > 0 && (
            <Segment
              basic
              textAlign="right"
              className={classNames([dark && 'inverted', 'pagination'])}>
              <Button
                icon="angle left"
                disabled={newDealersPageNumber === 0}
                onClick={this.decreaseNewDealersPage}
              />
              {newDealersPageNumber + 1} / {newDealersPages}
              <Button
                icon="angle right"
                disabled={newDealersPageNumber + 1 === newDealersPages}
                onClick={this.increaseNewDealersPage}
              />
            </Segment>
          )}
        </Segment>

        <Segment
          disabled={!dealerState.updated_count > 0}
          attached
          className={classNames([dark && 'inverted', 'payload', 'clip'])}>
          <Header size="medium" className="payload-title">
            {I18n.t('admin.importer.dealers.updated_dealers')}
            <Badge count={dealerState.updated_count} />
            <Button
              disabled={!dealerState.updated_count > 0}
              inverted={dark}
              content={I18n.t('admin.importer.dealers.import_all')}
              size="tiny"
              floated="right"
              icon={config.icons.modalApprove}
              onClick={() =>
                confirmationModal({
                  icon: config.icons.modalApprove,
                  title: I18n.t('admin.importer.dealers.import_changed'),
                  text: I18n.t(
                    'admin.importer.dealers.import_updated_confirmation',
                    { numItems: dealerState.updated_count }
                  ),
                  button: I18n.t('admin.importer.dealers.import_all'),
                  confirm: () => updateAllDealers(),
                })
              }
            />
          </Header>
          <Table
            inverted={dark}
            sortable
            compact
            size="small"
            selectable
            singleLine
            basic="very"
            className="spaced">
            <Table.Body
              children={this.getDealerRows(
                dealerState['updated'],
                config.nodes.dealersCompare,
                'updatedDealersPageNumber'
              )}
            />
          </Table>
          {updatedDealersPages > 0 && (
            <Segment
              basic
              textAlign="right"
              className={classNames([dark && 'inverted', 'pagination'])}>
              <Button
                icon="angle left"
                disabled={updatedDealersPageNumber === 0}
                onClick={this.decreaseUpdatedDealersPage}
              />
              {updatedDealersPageNumber + 1} / {updatedDealersPages}
              <Button
                icon="angle right"
                disabled={updatedDealersPageNumber + 1 === updatedDealersPages}
                onClick={this.increaseUpdatedDealersPage}
              />
            </Segment>
          )}
        </Segment>

        <Segment
          disabled={!dealerState.deleted_count > 0}
          attached
          className={classNames([dark && 'inverted', 'payload', 'clip'])}>
          <Header size="medium" className="payload-title">
            {I18n.t('admin.importer.dealers.deleted_dealers')}
            <Badge count={dealerState.deleted_count} />

            <Button
              disabled={!dealerState.deleted_count > 0}
              inverted={dark}
              content={I18n.t('admin.importer.dealers.archive_all')}
              size="tiny"
              floated="right"
              icon={config.icons.modalDelete}
              onClick={() =>
                confirmationModal({
                  negative: true,
                  icon: config.icons.modalDelete,
                  title: I18n.t('admin.importer.dealers.archive_deleted'),
                  text: I18n.t(
                    'admin.importer.dealers.archive_deleted_confirmation',
                    { numItems: dealerState.deleted_count }
                  ),
                  button: I18n.t('admin.importer.dealers.archive_all'),
                  confirm: () => archiveAllDealers(),
                })
              }
            />
          </Header>
          <Table
            inverted={dark}
            sortable
            compact
            size="small"
            selectable
            singleLine
            basic="very"
            className="spaced">
            <Table.Body
              children={this.getDealerRows(
                dealerState['deleted'],
                config.nodes.user,
                'deletedDealersPageNumber'
              )}
            />
          </Table>

          {deletedDealersPages > 0 && (
            <Segment
              basic
              textAlign="right"
              className={classNames([dark && 'inverted', 'pagination'])}>
              <Button
                icon="angle left"
                disabled={deletedDealersPageNumber === 0}
                onClick={this.decreaseDeletedDealersPage}
              />
              {deletedDealersPageNumber + 1} / {deletedDealersPages}
              <Button
                icon="angle right"
                disabled={deletedDealersPageNumber + 1 === deletedDealersPages}
                onClick={this.increaseDeletedDealersPage}
              />
            </Segment>
          )}
        </Segment>
      </div>
    )
  }
}

ImporterDealers = connect(mapStateToProps, mapDispatchToProps)(ImporterDealers)
export default ImporterDealers



// WEBPACK FOOTER //
// ./src/components/admin/Importer/ImporterDealers.jsx